import React, { useState } from "react";

function DateRangeReport({ field, onChange }) {
  const [start, setStart] = useState();
  const [end, setEnd] = useState();

  function _onChange(startDate, endDate) {
    startDate.setHours(5, 0, 0, 0); // Set start time to 5:00 AM
    endDate.setHours(4, 59, 59, 999); // Set end time to 4:59 AM on the next day
    endDate.setDate(endDate.getDate() + 1); // Move end date to the next day
    const where = {};
    where[field] = {
      $gte: startDate.toISOString(),
      $lte: endDate.toISOString(),
    };
    onChange(where);
  }

  function _onChangeStart(date) {
    setStart(date.toISOString().slice(0, 10));
    end && _onChange(date, new Date(end));
  }

  function _onChangeEnd(date) {
    setEnd(date.toISOString().slice(0, 10));
    start && _onChange(new Date(start), date);
  }

  return (
    <div className="d-flex flex-column flex-md-row gap-1 col-12 col-md-">
      <input
        className="form-control form-control-md shadow-none"
        value={start}
        onInput={(e) => _onChangeStart(e.target.valueAsDate)}
        type="date"
        placeholder="Start Date"
      />
      <input
        className="form-control form-control-md shadow-none"
        value={end}
        onInput={(e) => _onChangeEnd(e.target.valueAsDate)}
        type="date"
        placeholder="End Date"
      />
    </div>
  );
}

export default DateRangeReport;
